import { get, post, put } from 'api/request';
import urls from 'configs/urls';

export const getUserAddress = ({ headers }) => get(headers, false, urls.orderUrls.getUserAddress);

export const addUserAddress = ({ headers, data }) =>
  put(headers, false, urls.orderUrls.addUserAddress, data);

export const searchProducts = ({ data }) => get(null, false, urls.orderUrls.searchProducts, data);

export const submitOrderBulk = ({ headers, data }) =>
  post(headers, false, urls.orderUrls.submitOrderBulk, data);

export const uploadOrderAttachments = ({ data }) =>
  post(null, false, urls.orderUrls.uploadOrderAttachments, data);
